import React, { useMemo } from 'react';

import GlobalShortcuts, { type GlobalShortcutsItem } from '@atlassian/global-shortcuts';
import { companyHub } from '@atlassian/global-shortcuts/company-hub';
import { jira } from '@atlassian/global-shortcuts/jira';
import { loom } from '@atlassian/global-shortcuts/loom';
import { teams } from '@atlassian/global-shortcuts/teams';

import { PEOPLE_DIRECTORY_SEARCH, COMPANY_HUB } from '@confluence/named-routes';
import { useSessionData } from '@confluence/session-data';

import { GlobalItemLoadables } from './GlobalItems/GlobalItemLoadables';
import { useOrderedAppShortcuts } from './useOrderedAppShortcuts';

function companyHubComponent(): GlobalShortcutsItem {
	return {
		...companyHub(() => COMPANY_HUB.toUrl()),
		component: GlobalItemLoadables.companyHub,
	};
}

type GlobalAppShortcutsProps = {
	orderedMenuConfig?: { menuId: string; visible: boolean }[];
};

export const GlobalAppShortcuts = ({ orderedMenuConfig = [] }: GlobalAppShortcutsProps) => {
	const { cloudId, orgId } = useSessionData();

	// Map shortcut configs to menu identifiers
	const shortcutItemsConfig = useMemo(() => {
		return {
			companyHubShortcut: companyHubComponent(),
			jiraShortcut: jira(() => ''),
			loomShortcut: loom(() => ''),
			teamsShortcut: teams(() => PEOPLE_DIRECTORY_SEARCH.toUrl()),
		};
	}, []);

	// Sort shortcut items based on the ordered menu config
	const orderedShortcuts = useOrderedAppShortcuts(shortcutItemsConfig, orderedMenuConfig);

	return (
		<GlobalShortcuts
			testId="global-app-shortcuts"
			cloudId={cloudId}
			orgId={orgId}
			shortcutItems={orderedShortcuts}
			promoteSite
			product="confluence"
		/>
	);
};
